import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import { OverlayComponent } from './overlay/overlay.component';

@NgModule({
  declarations: [LoaderComponent, OverlayComponent],
  imports: [CommonModule],
  exports: [LoaderComponent, OverlayComponent],
})
export class LoaderModule {}
